import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative z-10 text-center" }
const _hoisted_2 = {
  class: "text-lg md:text-2xl mb-4",
  "data-aos": "fade-up",
  "data-aos-delay": "400"
}
const _hoisted_3 = ["href"]

import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import CountdownComponent from "./Countdown.vue";
import backgroundImage from "../assets/img/Background_Content.jpg";


export default /*@__PURE__*/_defineComponent({
  __name: 'WeddingContent',
  setup(__props) {

const route = useRoute();
const countdownFinished = ref(false);

const eventDate = computed(() => {
  const path = route.path.toLowerCase();
  return path.includes("syifa") ? "2025-06-27T00:00:00" : "2025-06-24T00:00:00";
});

const eventDateFormatted = computed(() => {
  const date = new Date(eventDate.value); // Pastikan gunakan .value di sini
  return date.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
});

const eventDateObject = computed(() => new Date(eventDate.value));
const googleCalendarUrl = computed(() => {
  const title = encodeURIComponent("Walimatul 'Ursy Syifa & Hidayat");
  const details = encodeURIComponent("Undangan pernikahan Syifa & Hidayat");
  const location = encodeURIComponent("Lokasi acara pernikahan"); // Optional
  const start = new Date(eventDateObject.value);
  const end = new Date(start.getTime() + 2 * 60 * 60 * 1000); // +2 jam

  const formatDate = (date: Date) =>
    date
      .toISOString()
      .replace(/[-:]|\.\d{3}/g, "")
      .slice(0, 15) + "Z";

  const dates = `${formatDate(start)}/${formatDate(end)}`;

  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${dates}&details=${details}&location=${location}&sf=true&output=xml`;
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", {
    id: "home",
    "data-aos": "slide-up",
    "data-aos-duration": "800",
    class: "section w-full h-[700px] bg-cover bg-center flex flex-col items-center justify-end text-white",
    style: _normalizeStyle({ backgroundImage: `url(${_unref(backgroundImage)})` })
  }, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", {
        class: "text-md md:text-5xl font-serif mb-2",
        "data-aos": "fade-up",
        "data-aos-duration": "1000"
      }, " Walimatul 'Ursy' ", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("h2", {
        class: "text-4xl md:text-6xl font-cursive font-black",
        "data-aos": "fade-up",
        "data-aos-delay": "200"
      }, " Syifa & Hidayat ", -1)),
      _createElementVNode("p", _hoisted_2, _toDisplayString(eventDateFormatted.value), 1),
      _createVNode(CountdownComponent, {
        targetDate: eventDateObject.value,
        class: "mt-2",
        onCountdownFinished: _cache[0] || (_cache[0] = ($event: any) => (countdownFinished.value = true))
      }, null, 8, ["targetDate"]),
      _createElementVNode("a", {
        href: googleCalendarUrl.value,
        target: "_blank",
        class: "inline-flex items-center gap-2 mt-4 mb-10 px-4 py-2 bg-blue-500 text-white font-semibold rounded-full shadow-md hover:bg-blue-800 transition",
        "data-aos": "fade-up",
        "data-aos-delay": "500"
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'calendar'],
          class: "text-white mr-2"
        }),
        _cache[1] || (_cache[1] = _createTextVNode(" Simpan di Kalender "))
      ], 8, _hoisted_3),
      _cache[4] || (_cache[4] = _createElementVNode("blockquote", {
        class: "relative mx-auto text-md md:text-xl italic p-4 rounded-lg bg-gradient-to-t from-blue-400 to-transparent w-full md:max-w-2xl md:bottom-4",
        "data-aos": "fade-up",
        "data-aos-delay": "600"
      }, " \"Dan di antara tanda-tanda (kebesaran)-Nya ialah Dia menciptakan pasangan-pasangan untukmu dari jenismu sendiri, agar kamu cenderung dan merasa tenteram kepadanya, dan Dia menjadikan di antaramu rasa kasih dan sayang.\" ", -1))
    ])
  ], 4))
}
}

})